var BrowserErrorType = /* @__PURE__ */ ((BrowserErrorType2) => {
  BrowserErrorType2[BrowserErrorType2["cache"] = 0] = "cache";
  BrowserErrorType2[BrowserErrorType2["plugin"] = 1] = "plugin";
  return BrowserErrorType2;
})(BrowserErrorType || {});
function getBrowserErrorType(error) {
  var _a, _b, _c;
  if (typeof error !== "object") {
    return null;
  }
  const browserError = error;
  if ((_a = browserError.message) == null ? void 0 : _a.includes("Minified React error #306")) {
    return 1;
  }
  if (((_b = browserError.name) == null ? void 0 : _b.startsWith("NS_ERROR_")) || ((_c = browserError.name) == null ? void 0 : _c.startsWith("QUOTA_EXCEEDED_"))) {
    return 0;
  }
  return null;
}
export {
  BrowserErrorType,
  getBrowserErrorType as default
};
//# sourceMappingURL=getBrowserErrorType.js.map
